import styles from './page9.module.css';

const QUOTE_ICON = '/assets/quote-icon.svg';

export default function Page9() {
    return (
        <div className={styles.page9}>
            <div className={styles.bgLines}>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
            </div>

            <div className={styles.contentWrapper}>
                <img
                    src={QUOTE_ICON}
                    alt="Quote"
                    className={styles.quoteIcon}
                />
                <h2 className={styles.quoteText}>
                    The gap between teaching and learning is where children fall behind. You can close it before it becomes a result.
                </h2>
            </div>
        </div>
    );
}
